import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmVariant?: 'default' | 'danger';
  isLoading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmVariant = 'default',
  isLoading = false,
}) => {
  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={open => !open && onClose()}
    >
      <Dialog.Portal>
        <Dialog.Overlay
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000,
          }}
        />
        <Dialog.Content
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: '#0f172a',
            border: '1px solid #1e293b',
            borderRadius: '8px',
            padding: '24px',
            width: '90%',
            maxWidth: '500px',
            zIndex: 1001,
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.5)',
          }}
        >
          <Dialog.Title
            style={{
              fontSize: '18px',
              fontWeight: 600,
              color: '#ffffff',
              marginBottom: '16px',
            }}
          >
            {title}
          </Dialog.Title>

          <Dialog.Description
            style={{
              fontSize: '14px',
              color: '#cbd5e1',
              lineHeight: '1.5',
              marginBottom: '24px',
              whiteSpace: 'pre-line',
            }}
          >
            {message}
          </Dialog.Description>

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '12px',
              paddingTop: '16px',
              borderTop: '1px solid #1e293b',
            }}
          >
            <button
              type="button"
              onClick={onClose}
              disabled={isLoading}
              className="btn btn-secondary btn-sm btn-inline"
              style={{
                minWidth: '80px',
              }}
            >
              {cancelText}
            </button>
            <button
              type="button"
              onClick={handleConfirm}
              disabled={isLoading}
              className={`btn btn-sm btn-inline ${
                confirmVariant === 'danger' ? 'btn-danger' : 'btn-primary'
              }`}
              style={{
                minWidth: '80px',
                backgroundColor: confirmVariant === 'danger' ? '#dc2626' : 'var(--accent-primary)',
              }}
            >
              {isLoading ? 'Processing...' : confirmText}
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default ConfirmationModal;
